import { QueryClient } from "@tanstack/react-query";
import axios from "axios";

const retryJitter = (retryTime = 3, delay = 1000, withJitter = true) => {
	return {
		retry: (failureCount: number, error: Error) => {
			const axiosError = error;

			if (axios.isAxiosError(axiosError)) {
				const status = axiosError.response?.status;
				if (status && status >= 400 && status < 500) {
					return false;
				}

				if (status === 500) {
					return false;
				}
			}
			return failureCount < retryTime - 1;
		},
		retryDelay: (attemptedIndex: number) => {
			const jitter = 0.5;
			const calcDelay = (attemptedIndex + 1) * delay;
			const jitteredDelay = calcDelay + Math.random() * calcDelay * jitter;

			return withJitter ? jitteredDelay : calcDelay;
		},
	};
};

const { retry, retryDelay } = retryJitter(3, 1000, true);

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000,
			refetchOnWindowFocus: false,
			retry,
			retryDelay,
		},
	},
});

export { queryClient, retryJitter };
